/**
 * SearchBar — DS Molecule
 */

import { useState } from 'react';
import styles from './SearchBar.module.css';

interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  onClear?: () => void;
  className?: string;
}

export function SearchBar({ placeholder = 'Rechercher...', value = '', onChange, onClear, className = '' }: SearchBarProps) {
  const [internal, setInternal] = useState(value);
  const current = onChange ? value : internal;
  const handleChange = (v: string) => { setInternal(v); onChange?.(v); };
  const handleClear = () => { setInternal(''); onChange?.(''); onClear?.(); };

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <i className={`bi bi-search ${styles.icon}`} />
      <input
        type="search"
        className={styles.input}
        placeholder={placeholder}
        value={current}
        onChange={e => handleChange(e.target.value)}
      />
      {current && (
        <button className={styles.clear} onClick={handleClear} type="button" aria-label="Effacer">
          <i className="bi bi-x" />
        </button>
      )}
    </div>
  );
}
